<aside class="sidebar" aria-label="Sidebar">
  <a class="brand" routerLink="/dashboard" aria-label="Ticket Monitor Home">
    <img
      src="/assets/MeterFeeder_Logo-01.png"
      alt="Meter Feeder"
      class="logo"
    />
    <span>Ticket Monitor</span>
  </a>
  <nav class="nav" aria-label="Primary">
    <a routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
    <a routerLink="/tickets" routerLinkActive="active">Tickets</a>
    <a routerLink="/vehicles" routerLinkActive="active">Vehicles</a>
    <a routerLink="/reports" routerLinkActive="active">Reports</a>
    <a routerLink="/payments" routerLinkActive="active">Payments</a>
    <a routerLink="/settings" routerLinkActive="active">Settings</a>
    @if (isGlobalAdmin$ | async) {
      <a routerLink="/clients" routerLinkActive="active">Clients</a>
    }
  </nav>
  <div class="account-actions">
    <a class="nav-link" routerLink="/account" routerLinkActive="active">
      <i class="fas fa-user-circle" aria-hidden="true"></i>
      Account
    </a>
    <button
      class="nav-link"
      type="button"
      (click)="logout()"
      aria-label="Sign out"
    >
      <i class="fas fa-sign-out-alt" aria-hidden="true"></i>
      Sign out
    </button>
  </div>
</aside>
